import { render, staticRenderFns } from "./WalkingForm.vue?vue&type=template&id=56a7b392"
import script from "./WalkingForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./WalkingForm.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports